// CUT OFF FIX (b), 11/10/2026: an invite pre-screen that did not complete.
// Before, the three web searches were never checked for a cut-off, and a cut or
// unreadable synthesis fell back to regulated: false, licenceStatus 'Unknown'.
// That fallback was saved as pre_screen_data; the dashboard read it as "Not
// found on register" and Alex read it as register intelligence. Now any search
// or the synthesis that fails, is cut off or cannot be read gives this form:
// regulated is null (never false), and every reader treats it as not checked.
export const INVITE_SEARCH_MAX_USES = 3; // web searches each invite research call may make
export function notCheckedPreScreen({ companyName = null, reason = 'the pre screen did not complete' } = {}) {
  return {
    checkStatus: 'not_checked', reason: String(reason).slice(0, 200), companyName,
    regulated: null, licenceStatus: 'Not checked', confidenceLevel: 'None',
    adverseNews: [], redFlags: [], sourcesChecked: [],
    preScreenedAt: new Date().toISOString(), preScreenedBy: 'Invite Pre Screen v4.0 (did not complete)',
  };
}
export function preScreenNotChecked(ps) {
  return !!(ps && typeof ps === 'object' && ps.checkStatus === 'not_checked');
}
// The dashboard's register line for a pre-screen that did not complete.
export const NOT_CHECKED_LINE = 'Not checked: the invite pre screen did not complete';
